var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconBed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.16699 11.6667V7.00001C1.16699 6.69059 1.28991 6.39385 1.5087 6.17505C1.72749 5.95626 2.02424 5.83334 2.33366 5.83334M2.33366 5.83334H11.667M2.33366 5.83334V3.50001C2.33366 3.19059 2.45658 2.89384 2.67537 2.67505C2.89416 2.45626 3.19091 2.33334 3.50033 2.33334H10.5003C10.8097 2.33334 11.1065 2.45626 11.3253 2.67505C11.5441 2.89384 11.667 3.19059 11.667 3.50001V5.83334M11.667 5.83334C11.9764 5.83334 12.2732 5.95626 12.4919 6.17505C12.7107 6.39385 12.8337 6.69059 12.8337 7.00001V11.6667M7.00033 2.33334V5.83334M1.16699 10.5H12.8337",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBed);
export default __webpack_public_path__ + "static/media/icon_bed.0f1f54fddd08aeafa2c1c4d4385aab60.svg";
export { ForwardRef as ReactComponent };